module.exports = __webpack_public_path__ + "static/tip_6-13344d39deccb679f4cea777aeec4dce.jpg";